import { Exam } from "./exam";
export class SelectedExams {
    constructor() {
        this.exams = {};
        this.wrapper = $("#selected-exams");
        this.noneSelected = $("#none-selected");
        this.totalExams = 0;
    }
    onAvailablePriceChanged(exam) {
        if (exam.selected) {
            if (!this.exists(exam)) {
                this.select(exam);
            }
        }
        else {
            this.unselect(exam);
        }
    }
    getExamsForCertificate(certificateId) {
        if (this.exams[certificateId] === undefined) {
            this.exams[certificateId] = [];
        }
        return this.exams[certificateId];
    }
    findExam(exam) {
        const exams = this.getExamsForCertificate(exam.certificate.id);
        for (const foundExam of exams) {
            if (foundExam.id == exam.id) {
                return foundExam;
            }
        }
        return undefined;
    }
    getLastExam(idCertificate) {
        const exams = this.getExamsForCertificate(idCertificate);
        if (exams.length === 0) {
            return undefined;
        }
        return exams[exams.length - 1];
    }
    exists(exam) {
        return this.findExam(exam) !== undefined;
    }
    select(exam) {
        this.getExamsForCertificate(exam.certificate.id).push(this.createSelected(exam));
        this.totalExams++;
        this.noneSelected.addClass("hidden");
    }
    createSelected(exam) {
        const selectedExam = new Exam(exam.parentWrapper.clone());
        const lastExam = this.getLastExam(exam.certificate.id);
        if (lastExam === undefined) {
            this.createTitle(exam.certificate);
            $(`#${exam.certificate.selectedTitleId}`).after(selectedExam.parentWrapper);
        }
        else {
            lastExam.parentWrapper.after(selectedExam.parentWrapper);
        }
        exam.partner = selectedExam;
        return selectedExam;
    }
    unselect(exam) {
        this.removeExam(exam);
        exam.partner = undefined;
        this.totalExams--;
        if (this.totalExams === 0) {
            this.noneSelected.removeClass("hidden");
        }
        if (this.getLastExam(exam.certificate.id) === undefined) {
            $(`#${exam.certificate.selectedTitleId}`).remove();
        }
    }
    removeExam(exam) {
        const idCertificate = exam.certificate.id;
        this.exams[idCertificate] = this.exams[idCertificate].filter((selectedExam) => {
            if (selectedExam.id != exam.id) {
                return true;
            }
            selectedExam.partner = undefined;
            selectedExam.parentWrapper.remove();
            return false;
        });
    }
    get all() {
        let exams = [];
        Object.getOwnPropertyNames(this.exams).forEach((key) => {
            exams = [...exams, ...this.exams[key]];
        });
        return exams;
    }
    createTitle(certificate) {
        const html = `<div class="certificate-title" id="${certificate.selectedTitleId}">` +
            `   <div>` +
            `       <h3>${certificate.name} <i class="fa fa-arrow-alt-right"></i></h3>` +
            `   </div>` +
            `</div>`;
        $(html).appendTo(this.wrapper);
    }
}
